export enum EXCEPTION_TYPE {
    FOR_PROFILES = 'for-profiles',
    FOR_PROFILE_KINDS = 'for-profile-kinds',
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/revenue/exceptions/entities/exception-type.model.ts